import React from "react";
import { useCompatRouter as useRouter } from "@/lib/compat-router/context";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

const Breadcrumb = ({ items, className = "" }: BreadcrumbProps) => {
  const router = useRouter();

  return (
    <div className={`border-b border-gray-200 bg-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center gap-2 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const showSeparator = index > 0;

            return (
              <React.Fragment key={index}>
                {showSeparator && <span className="text-gray-300">/</span>}
                {isLast || !item.href ? (
                  <span
                    className={
                      isLast
                        ? "text-[#2D96A7] font-medium truncate"
                        : "text-gray-500"
                    }
                  >
                    {item.label}
                  </span>
                ) : (
                  <button
                    onClick={() => router.push(item.href!)}
                    className="text-gray-500 hover:text-gray-800 transition-colors duration-200"
                  >
                    {item.label}
                  </button>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
